import { IGetBannersListDTO } from '@/models/banners.model';
import { TGetBannersQuery } from '../helpers';

class GetBannersListDTO implements IGetBannersListDTO {
  title?: string;
  description?: string;
  start_date?: string;
  expiration_date?: string;
  active?: '0' | '1';
  limit?: number;

  constructor({ title, description, start_date, expiration_date, active }: TGetBannersQuery) {
    this.title = title;
    this.description = description;
    this.start_date = start_date;
    this.expiration_date = expiration_date;
    this.active = active;
  }
}

export default GetBannersListDTO;
